/**
 * 登录检查 Mixin
 * @description 提供登录状态检查方法，未登录时触发登录弹窗
 */
export default {
  methods: {
    /**
     * 检查是否已登录
     * @returns {boolean} 是否已登录
     */
    isLoggedIn() {
      return !!localStorage.getItem('token')
    },

    /**
     * 需要登录时的操作包装器
     * @param {Function} callback - 登录后要执行的回调函数
     * @returns {boolean} 是否已登录，true 表示已登录可以继续执行
     */
    requireLogin(callback) {
      if (this.isLoggedIn()) {
        if (callback && typeof callback === 'function') {
          callback()
        }
        return true
      }
      if (this.$route) {
        const redirectRoute = {
          path: this.$route.path,
          query: this.$route.query
        }
        sessionStorage.setItem('redirectRoute', JSON.stringify(redirectRoute))
      }
      // 触发全局登录弹窗事件
      this.$eventBus.$emit('show-login')
      this.$message.warning('请先登录后再操作')
      return false
    }
  }
}
